"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssigneeInitials = AssigneeInitials;
var jsx_runtime_1 = require("react/jsx-runtime");
var initials_1 = require("../../../utils/initials");
function AssigneeInitials(props) {
    var SIZE_CLASSES = {
        sm: "size-6 text-[9px]",
        md: "size-7 text-[10px]",
    };
    var name = props.name, _a = props.size, size = _a === void 0 ? "md" : _a, _b = props.className, className = _b === void 0 ? "" : _b;
    var initials = (0, initials_1.getInitials)(name);
    if (!initials) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("span", { "aria-label": "Assigned to ".concat(name), title: name, className: "flex items-center justify-center rounded-md bg-primary-navy text-white font-semibold shrink-0 ".concat(SIZE_CLASSES[size], " ").concat(className), children: initials }));
}
